import React, { useEffect, useState } from "react";
// import axiosInstance from "../../utils/axiosApi";
import axiosInstance from "../../utils/axiosKeycloakApi";
import { useParams } from "react-router-dom";

const OnderhoudstaakEdit = () => {
  let { id } = useParams();
  const [omschrijving, setOmschrijving] = useState("");
  const [kosten, setKosten] = useState("");

  const retrieveOnderhoudstaak = () => {
    try {
      axiosInstance.get(`onderhoudstaken/${id}/`).then((response) => {
        console.log("retrieve response is", response)
        console.log("status code is ", response.status)
        setOmschrijving(response.data.omschrijving);
        setKosten(response.data.kosten);
      });
    } catch (e) {
      console.log(e);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await axiosInstance.patch(`onderhoudstaken/${id}/`, {
        omschrijving: omschrijving,
        kosten: kosten,
      }).then( response =>{
        try{
          if(response.response.status==403){
            alert("Forbidden! You do not have permission to perform this action.");
            return (window.location = "/app/");
          } else {
            alert("Bewerking voltooid!");
            return (window.location = "/app/");
          };
        } catch(e){
          alert("Bewerking voltooid!");
          return (window.location = "/app/");
          console.log("operation seems successfull, known error",e);
        }
       
      });
      // return (window.location = "/app/onderhoudstaken");
    } catch (e) {
      return alert(`Error-omschrijving: ${e}`);
    }
  };

  useEffect(() => {
    retrieveOnderhoudstaak();
  }, []);

  return (
    <>
      <section className="section">
        <div className="container box" style={{ width: "50%" }}>
          <h1 className="title is-2">Bewerk onderhoudstaak</h1>
          <div className="field">
            <label className="label">Omschrijving</label>
            <div className="control has-icons-left">
              <input
                name="plaats"
                className="input"
                type="text"
                placeholder="Omschrijving"
                defaultValue={omschrijving}
                onChange={(e) => setOmschrijving(e.target.value)}
              />
              <span className="icon is-small is-left">
                <i class="far fa-file-alt"></i>
              </span>
            </div>
          </div>
          <div className="field">
            <label className="label">Kosten</label>
            <div className="control has-icons-left">
              <input
                name="plaats"
                className="input"
                type="number"
                placeholder="Kosten"
                defaultValue={kosten}
                onChange={(e) => setKosten(e.target.value)}
              />
              <span className="icon is-small is-left">
                <i class="fas fa-money-check-alt"></i>
              </span>
            </div>
          </div>
          <div className="field is-grouped">
            <div className="control">
              <button
                onClick={handleSubmit}
                className="button is-primary is-outlined is-small"
              >
                <i class="far fa-save"></i>
                Opslaan
              </button>
            </div>
            <div className="control">
              <button
                onClick={() => (window.location = `/app/onderhoudstaken/`)}
                className="button is-danger is-outlined is-small"
              >
                <i class="fas fa-ban"></i>
                Annuleren
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OnderhoudstaakEdit;
